import {LocalStore} from "@khan/util-local-store";

import type {ProfileModelType} from "#shared-package/profile-model.ts";
import {getBannerShownKey} from "#site-banners/utils/keys.ts";

const AUTO_DISMISS_TIMEOUT = 1000 * 60 * 30; // 30 minutes

/**
 * Check if a banner should be auto-dismissed based on when it was shown.
 * Returns true if the banner was shown more than 30 minutes ago.
 */
export const shouldAutoDismissBanner = (
    bannerName: string,
    profile: ProfileModelType | null,
): boolean => {
    const shownKey = getBannerShownKey(bannerName, profile);
    const shownTimestamp = LocalStore.get(shownKey);

    if (!shownTimestamp) {
        return false;
    }

    const shownDate = new Date(shownTimestamp);
    const now = new Date();
    const timeElapsed = now.getTime() - shownDate.getTime();

    return timeElapsed > AUTO_DISMISS_TIMEOUT;
};

/**
 * Store the timestamp when a banner is shown.
 */
export const persistBannerShownTimestamp = (
    bannerName: string,
    profile: ProfileModelType | null,
): void => {
    const shownKey = getBannerShownKey(bannerName, profile);
    const shownTimestamp = new Date().toISOString();

    LocalStore.set(shownKey, shownTimestamp);
};

/**
 * Clear the shown timestamp when a banner is dismissed.
 */
export const clearBannerShownTimestamp = (
    bannerName: string,
    profile: ProfileModelType | null,
): void => {
    const shownKey = getBannerShownKey(bannerName, profile);
    LocalStore.del(shownKey);
};
